// extracted by mini-css-extract-plugin
export default {"paper":"styles_paper__yylTX","margin-bottom":"styles_margin-bottom__o9Lph","button":"styles_button__dtkhl"};